import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f5ecace&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=2f5ecace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ecace",
  null
  
)

export default component.exports